import { _ } from "i18n";
import { VideoSidebar } from "../../../types";
import { useContext, useEffect, useRef, useState } from "react";
import type React from "react";
import "./create.css";
import { useVideoPlayer } from "../../../Contexts/contexts";
import { useGameStore } from "../../../store";

interface CreateComponentProps {
	show: boolean;
	onShowChange: (show: boolean) => void;
	fullscreen: boolean;
	sidebar: VideoSidebar | null;
	clipsAllowed: boolean;
}

export function CreateButtonComponent({ show, onShowChange, fullscreen, sidebar, clipsAllowed }: CreateComponentProps) {
	const { setSidebar } = useGameStore();

	const [showCreateMenu, setShowCreateMenu] = useState(false);
	const menuRef = useRef<HTMLDivElement | null>(null);
	const { playerRef } = useVideoPlayer();
	const buttonRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		function handleClickOutside(event: MouseEvent) {
			if (
				menuRef.current &&
				!menuRef.current.contains(event.target as Node) &&
				buttonRef.current &&
				!buttonRef.current.contains(event.target as Node)
			) {
				setShowCreateMenu(false);
			}
		}
		document.addEventListener("mousedown", handleClickOutside, { passive: true });
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const handleButtonClick = (e: React.MouseEvent<HTMLDivElement>) => {
		e.stopPropagation();
		setShowCreateMenu(!showCreateMenu);
	};

	return (
		<div className="create-container">
			<div
				className="createButton"
				ref={buttonRef}
				style={show && fullscreen && sidebar ? { marginRight: "420px" } : {}}
				onClick={handleButtonClick}
				onTouchStart={(e) => e.stopPropagation()}
			>
				<div className="plusSign">+</div>
				<div className="createText">{_("permission.create")}</div>
			</div>
			{showCreateMenu && (
				<div className="createMenu-container" style={show && fullscreen && sidebar ? { marginRight: "420px" } : {}} ref={menuRef}>
					<div
						className="createMenuItem"
						onClick={() => {
							setSidebar(VideoSidebar.CreateEvent);
							setShowCreateMenu(false);
							onShowChange(true);
							playerRef?.current?.pause();
						}}
					>
						<div className="itemName">{_("gamePage.createEvent.label")}</div>
						<div className="itemDescription">{_("gamePage.createEvent.desc")}</div>
					</div>
					{clipsAllowed && (
						<div
							className="createMenuItem"
							onClick={() => {
								setSidebar(VideoSidebar.CreateClip);
								setShowCreateMenu(false);
								onShowChange(true);
								playerRef?.current?.pause();
							}}
						>
							<div className="itemName">{_("gamePage.createCustomClip.label")}</div>
							<div className="itemDescription">{_("gamePage.createCustomClip.desc")}</div>
						</div>
					)}
				</div>
			)}
		</div>
	);
}
